import { useRef, type ReactNode } from "react";

/** Hidden file input + Choose button + filename readout (U8) — the trio that
 *  was hand-built at three sites (CSV ×2, firmware .bin). Filename shows only
 *  once a file is picked (the "no file" placeholder was removed by request). */
export function FilePick({ accept, label, fileName, onFile, before }: {
  accept: string;
  label: string;
  fileName: string;
  onFile: (file: File | null) => void;
  /** render the filename BEFORE the button (right-aligned action rows) */
  before?: boolean;
}) {
  const ref = useRef<HTMLInputElement>(null);
  const name: ReactNode = fileName ? (
    <span style={{ fontSize: 11, color: "var(--t-mute)", maxWidth: 240, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
      {fileName}
    </span>
  ) : null;
  return (
    <>
      <input ref={ref} type="file" accept={accept} style={{ display: "none" }}
        onChange={(e) => onFile(e.target.files?.[0] ?? null)} />
      {before && name}
      <button type="button" className="btn ghost" onClick={() => ref.current?.click()}>{label}</button>
      {!before && name}
    </>
  );
}
